import { IntlShape } from "react-intl";
import { ITasOccurrence } from "../models/tasOccurrence";
import ApiService from "../services/api";

const tasStatusMap = {
    "OPEN": "intl-msg:shared.apiError.tas.statusOpen",
    "IN_ANALYSIS": "intl-msg:shared.apiError.tas.statusInAnalysis",
    "ANSWERED": "intl-msg:shared.apiError.tas.statusAnswered",
    "FINISHED": "intl-msg:shared.apiError.tas.statusFinished",
    "CANCELLED": "intl-msg:shared.apiError.tas.statusCancelled",
}

const getTasStatusLabel = (intl: IntlShape, status?: string): string | undefined => {
    const id = tasStatusMap[status as keyof typeof tasStatusMap];
    return id ? intl.formatMessage({ id }) : undefined;
}

export const fetchTasOccurrences = async (chassis: string, intl: IntlShape): Promise<ITasOccurrence[]> => {
    const apiService = new ApiService(import.meta.env.VITE_API_URL, 'api/v1/tas');
    try {
        const response = await apiService.get(`/vehicles/${chassis}/tas-occurrences`);

        if (response.status === 200) {
            return (response.data as ITasOccurrence[])
                .filter(tas => tas.tasOccurrenceNumber)
                .map(tas => ({
                    ...tas,
                    status: getTasStatusLabel(intl, tas.status),
                }))
                .sort((a, b) => new Date(b.createdAt ?? "").getTime() - new Date(a.createdAt ?? "").getTime());
        } else {
            throw new Error('Erro ao buscar ocorrências TAS');
        }
    } catch (error) {
        console.error('Error fetching tas occurrences:', error);
        throw error;
    }
}

export const fetchTasOccurrence = async (chassis: string, tasNumber: string, intl: IntlShape): Promise<ITasOccurrence | null> => {
    const apiService = new ApiService(import.meta.env.VITE_API_URL, 'api/v1/tas');
    try {
        const response = await apiService.get(`/vehicles/${chassis}/tas-occurrences/${tasNumber}`);
        if (response.status === 200) {
            const data = response.data as ITasOccurrence;
            return {
                ...data,
                status: getTasStatusLabel(intl, data.status),
            };
        } else {
            throw new Error('Erro ao buscar ocorrência TAS');
        }
    } catch (error) {
        console.error('Error fetching tas occurrence:', error);
        throw error;
    }
}